import { useRef, useEffect, useState } from "react";
import ChevronRight from "../../icons/chevronRight";
import { useTranslation } from "react-i18next";

const AccordionItem = ({ question, answer, isOpen, onClick }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isOpen]);
  const { t } = useTranslation();
  return (
    <div
      className={`my-2 shadow-mainShadow relative cursor-pointer overflow-hidden  p-8  transition-all  bg-white rounded-xl ${
        isOpen ? "bg-white border-2  border-mainRed" : "bg-[#f9f8fc]"
      }
`}
      onClick={onClick}
    >
      <button
        className={`w-full  text-left flex justify-between items-center transition-colors `}
      >
        <span className="font-bold text-[20px]">{t(question)}</span>
        <div
          className={`flex items-center transition-all justify-center rounded-full shadow-[0px_0px_24px_-12px_black] top-2 right-2 size-10 ${
            isOpen ? "rotate-90 bg-mainRed" : ""
          }`}
        >
          <ChevronRight stroke={isOpen ? "white" : ""} />
        </div>
      </button>

      <div
        ref={contentRef}
        style={{
          maxHeight: height,
        }}
        className="mt-4 overflow-hidden text-gray-600 duration-300 ease-in-out transition-max-height"
      >
        <div className="max-w-[650px]">{t(answer)}</div>
      </div>
    </div>
  );
};

export default AccordionItem;
